import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";

import HeroSection from "./components/HeroSection";
import StatementSection from "./components/StatementSection";
import PropertySolutionsSection from "./components/PropertySolutionsSection";
import IntelligentSection from "./components/IntelligentSection";
import ChargingEasySection from "./components/ChargingEasySection";
import ServiceSection from "./components/ServiceSection";
import LogoCarouselSection from "./components/LogoCarouselSection";
import JourneyCardsSection from "./components/JourneyCardsSection";
import ClientProfileSection from "./components/ClientProfileSection";
import NewsCarouselSection from "./components/NewsCarouselSection";
import NewsSection from "./components/NewsSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  // Initialize Lenis smooth scroll
  useSmoothScroll();

  return (
    <div className="min-h-screen">
      <Seo
        title="Zweering Elektrotechnik | Photovoltaik & Elektro-Meisterbetrieb Emmerich am Rhein"
        description="Elektro-Meisterbetrieb in Emmerich am Rhein: Photovoltaik, Speicher, Wallbox, Wärmepumpe und Smart-Home aus einer Hand. Über 400 PV-Anlagen am Niederrhein."
        canonical="https://zweering.de/"
        breadcrumbs={[{ name: "Startseite", url: "https://zweering.de/" }]}
      />
      <Header />
      <main id="main-content">

        <HeroSection />
        <StatementSection />
        <PropertySolutionsSection />
        <IntelligentSection />
        <ChargingEasySection />
        <ServiceSection />
        <JourneyCardsSection />
        <ClientProfileSection />
        <NewsCarouselSection />
        {/* NewsSection vorerst ausgeblendet bis Artikel vorhanden sind */}
        {false && <NewsSection />}
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}